<template lang="pug">
  .box-exercise
    .box-exercise-top  
      span.beehive 
          img(src="../../../../assets/images/faces/ic_mark_baitapp@2x.png")          
      .title {{$t("landing.exercise.title")}}
      router-link.view-more(:to="{ path: getLinkMoreAll() + '/exercise'}") {{$t("home.view_more")}} >>
    .box-exercise-search
      .input-group
        input(:placeholder="$t('landing.exercise.keyword')" v-model="key_exercise" @keyup="onExerciseChange")
        .addons-button-clear(@click="onExerciseClear" v-bind:style="clear_exercise ? 'display:block;' : 'display:none;' ")
        .addons-button(@click="onExerciseSearch")
            span.material-icons search
    .box-exercise-content
      .row(v-if="lstExercises && lstExercises.length")
        div(v-for="(exercise, index) in lstExercises")
          FrontItem.col-md-4.col-sm-6.col-xs-12(:exercise="exercise" :key="count" :obj_id="exercise.id", :url="getLinkMore()")
        .clearfix
        router-link.view-more.mobile(:to="{ path: getLinkMoreAll() + '/exercise'}") {{$t("home.view_more")}} >>
      .row(v-else)
          .no-data.col-md-12.col-sm-12.col-xs-12 {{no_data}}
    .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../../Model/graphqlfront'
import FrontItem from './item'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    FrontItem,
    MdNotification
  },
  props: {
    teacherID: String,
    item: Object,
    pcInfo: Object
  },
  data() {
    return {
      lstExercises: [],
      key_exercise: '',
      clear_exercise: 0,
      itemPC: this.pcInfo,
      lstLikes: [],
      count: 0,
      message: this.$t('home.comming_soon'),
      no_data: this.$t('home.no_data')
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    getLinkMore() {
      return this.$route.name + '/' + this.itemPC.site_id + '/' + this.$mycontroller.doSanitizeTitle(this.itemPC.name) + '-' + this.itemPC.id
    },
    getLinkMoreAll() {
      return this.$mycontroller.doSanitizeTitle(this.itemPC.name) + '-' + this.itemPC.id
    },
    onExerciseSearch() {
      if (this.key_exercise.length > 0) {
        var query = this.$route.query
        query = Object.assign(query, {keyword: this.key_exercise})
        this.$router.push({path: this.getLinkMoreAll() + '/exercise', params: this.$route.params, query: query})
      }
      // this.autoRefresh()
    },
    onExerciseChange(events) {
      if (events.key === 'Enter') {
        this.onExerciseSearch()
      } else {
        if (this.key_exercise.trim().length) this.clear_exercise = 1
        else this.onExerciseClear()
      }
    },
    onExerciseClear() {
      this.key_exercise = ''
      this.clear_exercise = 0
      this.autoRefresh()
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    commingSoon() {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    async autoRefresh() {
      this.lstExercises = []
      var objWhere = {
        exercise_classes: {
          class: {
            pc_id: {_eq: this.itemPC.id}
          }
        }
      }
      // if (this.$store.getters.isLoggedIn) {
      //   QUERY = graphql.GET_EXERCISE_USER
      //   objWhere = Object.assign(objWhere, {user_id: {_eq: this.$store.getters.user}})
      // }
      if (this.key_exercise !== '') {
        objWhere = Object.assign(objWhere, {_or: [{name: {_ilike: '%' + this.key_exercise + '%'}}]})
      }
      var variables = {
        where: objWhere,
        order_by: {updated_at: 'desc'},
        limit: 6
      }
      await this.$apollo.query({
        query: gql(graphql.GET_EXERCISE),
        fetchPolicy: 'no-cache',
        variables: variables
      }).then((response) => {
        this.lstExercises = response.data.v_front_exercise
      }).catch((error) => {
        console.log('error', error)
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0, this.$route.params, this.$route.query)
        }
      })
    },
    increment() {
      this.count++
    }
  },
  async mounted () {
    await this.autoRefresh()
    if (this.$route.query.like !== undefined && Number(this.$route.query.like) > 0 && this.object_id === Number(this.$route.query.like)) {
      this.increment()
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.front-landing-page{
  .content.front{
    .box-exercise{margin-top:0; margin-bottom: 0px;
      .box-exercise-top{
        .title{text-align: left;font-weight: bold; font-size: 25px;letter-spacing: 0px;color: #23180A;text-transform: uppercase; display: inline-block; position: relative;}
        .view-more{cursor: pointer; float: right; color: #1A0DAB; font-size:15px;margin-top:5px;}
        .view-more.mobile{display: none;}
        span.beehive { width: 42px; height: 50px;transform: matrix(0, 1, -1, 0, 0, 0); position: relative;margin-right: 7px;top: -5px;
          img {max-width: 100%; width: 50px;}
        }
      }
      .box-exercise-search{margin: 10px 0 20px;position: relative;
        input{display:block; box-shadow: 0px 3px 6px #00000029; border: 1px solid #9F6A28; border-radius: 10px; padding: 12px 75px 12px 15px; width: 500px;background: #fff;}
        input::placeholder{color: #B4B4B4;}
        input::-moz-placeholder{color: #B4B4B4;}
        input::-webkit-input-placeholder {color: #B4B4B4;}
        input::-ms-input-placeholder {color: #B4B4B4;}
        .addons-button{cursor: pointer; background: #FFEF45; display: inline-block; position: absolute; right:1.5px; top:1.5px;width: 40px;  height: 44px;border-radius: 10px; border-top-left-radius: 0;border-bottom-left-radius: 0;
            span{transform: translate(9px, 12px); color: #9F6A28;}
        }
        .addons-button-clear{cursor: pointer;display: none; background: url("../../../../assets/images/faces/ic_clear_24px.png") no-repeat center center; position: absolute; right:40px; top:1px;width: 40px;  height: 44px;border-radius: 5px; border-top-left-radius: 0;border-bottom-left-radius: 0;}
      }
      .box-exercise-content{
        .box-parent-exercise{margin-bottom:30px;
          .box-item-exercise{cursor: pointer; border-radius: 10px; position: relative; height: 130px; overflow: hidden; box-shadow: 0px 1px 3px #00000029; 
            .overlay{width: 100%; position: absolute;height:100%; background: transparent linear-gradient(180deg, #FFED98 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box; top:0;}
            a{display: inline-block;
              &.grade-format{position: relative; background: #000000 0% 0% no-repeat padding-box; border-radius: 5px; color: #FFFFFF; font-size: 12px; margin: 8px 15px; padding: 4px 8px; z-index: 995; opacity: 0.5;}
            }
            .item-title{ position: relative; padding: 0 15px;width: 100%;
              span{color: #333333; font-weight: 400;}
            }
          }
          .item-social{margin-top:10px; display: table; width:100%;
              span { display: table-cell;  width: 33.33%;font-size:13px;
                i{color:#4B2D15; font-size:13px;
                    &:before{padding-right: 5px;}
                    img{width: 16px; height: 16px; margin-right: 5px; position: relative; top:-2px;}
                }
                i.like{cursor: pointer;}
              }
          }
        }
        .view-more.mobile{display: none; color: #1A0DAB;}
        .no-data{text-align: center; margin: 15px 0;color: #9F6A28; font-size:15px;}
      }
    }
  }
}
@media (max-width: 1366px){
  .content.front{
    .box-exercise{
      .box-exercise-content{
        .view-more.mobile{ display: none;}
      }
    }
  }
}
@media (max-width: 1024px){
  .content.front{
    .box-exercise{
      .box-exercise-content{
        .view-more.mobile{ display: none; }
      }
    }
  }
}
@media (max-width: 991px){
  .content.front{
    .box-exercise{
      .box-exercise-content{
        .box-parent-exercise{width: 50%;}
        .view-more.mobile{ display: none;}
      }
    }
  }
}
@media (max-width: 768px){
  .content.front{
    .box-exercise{
      .box-exercise-top{
        .title{font-size:20px;}
      }
      .box-exercise-search{
        .input-group{width: 100%;
            input{width: 100%;}
        }
      } 
    }
  }
}
@media (max-width: 560px){
  .content.front{
    .box-exercise{
      .box-exercise-top{
        .title{font-size:18px;}
        .view-more{display: none;}
      }
      .box-exercise-content{
        .view-more.mobile{ display: block !important; text-align: center; margin-bottom:20px;}
        .box-parent-exercise{width: 100% !important;
          .box-item-exercise{height: 150px;}
        }
      }
      .box-exercise-search{
        .input-group{width: 100%;
            input{width: 100%;}
        }
      } 
    }
  }
}
@media (max-width: 375px){
  .content.front{
    .box-exercise{
      .box-exercise-top{
        .title{font-size:18px;}
        .view-more{display: none;}
      }
      .box-exercise-content{
        .view-more.mobile{ display: block; text-align: center; margin-bottom:20px;}
        .box-parent-exercise{width: 100%;
            .box-item-exercise{height: 150px;}
        }
      }
      .box-exercise-search{
        .input-group{width: 100%;
            input{width: 100%;}
        }
      } 
    }
  }
}
</style>




// WEBPACK FOOTER //
// index.vue?75be6e42